export default {
    data() {
        return {
            edit: false,
            loading: false,
            confirmDialogVisible: false,
            pendingCallback: null,
            oldConfig: {},
            rules: {
                clientId: [
                    { maxLength: 128, message: '不得超过128个字符', trigger: 'blur, submit' },
                    { required: true, trim: false, trigger: 'blur, submit' },
                ],
                clientSecret: [
                    { maxLength: 512, message: '不得超过512个字符', trigger: 'blur, submit' },
                    { required: true, trim: false, trigger: 'blur, submit' },
                ],
                profile: [
                    { maxLength: 1024, message: '不得超过1024个字符', trigger: 'submit' },
                    {
                        validate: value => !value.length || String(value).startsWith('https'),
                        message: '请输入以https开头的地址',
                        trigger: 'submit',
                    },
                ],
                tenantId: [
                    { maxLength: 512, message: '不得超过512个字符', trigger: 'blur, submit' },
                    { required: true, trim: false, trigger: 'blur, submit' },
                ],
            },
        };
    },

    computed: {
        isDisabled() {
            if (this.loading) {
                return true;
            }

            if (!this.hasChange) {
                return true;
            }

            return false;
        },

        hasChange() {
            if (JSON.stringify(this.oldConfig) === JSON.stringify(this.config)) {
                return false;
            }
            return true;
        },
    },

    watch: {
        edit(val) {
            this.$emit('update:edit', val);
        },
    },

    created() {
        this.loading = true;
        this.getInitData();
    },

    methods: {
        getBeforeConfig(url) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.$ajax.gatewayGet(url, {}, {
                    customFn: (res) => {
                        this.loading = false;
                        this.$message.error(res.message || '获取失败，请稍后重试');
                    },
                })
                .then((res) => {
                    if (res && res.code === 0) {
                        const data = res.data || {};
                        this.loading = false;
                        resolve(data);
                    } else {
                        this.loading = false;
                        this.$message.error(res?.message || '获取失败，请稍后重试');
                        reject(new Error(res?.message || '获取失败'));
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error(err.message || '获取失败，请稍后重试');
                    reject(err);
                });
            });
        },

        saveData(url, params) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.$ajax.gatewayPost(url, params, {
                    customFn: (res) => {
                        this.loading = false;
                        this.$message.error(res.message || '保存失败，请稍后重试');
                    },
                })
                .then((res) => {
                    if (res && res.code === 0) {
                        this.$message.success('保存成功');
                        this.edit = false;
                        this.loading = false;
                        resolve(true);
                    } else {
                        this.loading = false;
                        this.$message.error(res?.message || '保存失败，请稍后重试');
                        reject(new Error(res?.message || '保存失败'));
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error(err.message || '保存失败，请稍后重试');
                    reject(err);
                });
            });
        },

        changeStatus() {
            this.edit = true;
        },

        showConfirmDialog(callback) {
            if (!this.hasChange) {
                callback && callback(true);
            }
            this.pendingCallback = callback;
            this.confirmDialogVisible = true;
        },

        handleDialogCancel() {
            this.edit = false;
            this.$nextTick(() => {
                this.pendingCallback && this.pendingCallback(true);
                this.pendingCallback = null;
            });
        },

        handleDialogClose() {
            this.pendingCallback && this.pendingCallback(false);
            this.pendingCallback = null;
        },

        async handleDialogConfirm() {
            const isValid = await this.validate();
            if (!isValid) {
                this.$message.error('请正确填写配置信息');
                this.handleDialogClose();
                return;
            }
            const success = await this.saveData(this.saveUrl, this.saveParams);
            if (success && this.pendingCallback) {
                this.pendingCallback(true);
                this.pendingCallback = null;
            }
        },

        async formSubmit(e) {
            e.preventDefault();
            const success = await this.saveData(this.saveUrl, this.saveParams);
            if (success) {
                this.getInitData();
            }
        },

        cancel() {
            this.config = JSON.parse(JSON.stringify(this.oldConfig));
            this.edit = false;
        },

        async validate() {
            const f = this.$refs.configForm || [];
            if (f) {
                const rs = await f.validate();
                const noError = rs.join('') === '';
                return noError;
            }

            return true;
        },
    },
};
